export default __webpack_public_path__ + "static/media/iphone-12.39e1f779.png";